import React from 'react'
import { Check } from 'lucide-react'
import {
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu'
import { buildViewToggleItems } from '../helpers/view-toggle-items'
import type { ViewToggleItem } from '../types/menu-items'
import type { MenubarViewToggles } from '../types/menubar-view-toggles'
import { DesktopSubmenu } from './desktop-submenu'

type DesktopViewMenuProps = {
  gridMode: 'off' | 'full' | 'half'
  viewToggles: MenubarViewToggles
  openGuidesDialog: () => void
}

const renderToggle = (item: ViewToggleItem, index: number) => (
  <DropdownMenuCheckboxItem
    key={index}
    checked={item.checked}
    disabled={item.disabled}
    onCheckedChange={(v) => {
      if (item.disabled) return
      item.set(v)
    }}
  >
    {item.label}
  </DropdownMenuCheckboxItem>
)

export const DesktopViewMenu: React.FC<DesktopViewMenuProps> = ({
  gridMode,
  viewToggles,
  openGuidesDialog,
}) => {
  const toggles = buildViewToggleItems(viewToggles)

  return (
    <DesktopSubmenu label="View">
      <DropdownMenuSub>
        <DropdownMenuSubTrigger className="relative pl-8 pr-2" onClick={viewToggles.clearGrid}>
          <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
            {(gridMode === 'full' || gridMode === 'half') && <Check className="h-4 w-4" />}
          </span>
          <span>Show Grid</span>
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent
          sideOffset={5}
          className="w-56 max-w-[90vw]"
          data-text-edit-keepalive=""
        >
          <DropdownMenuCheckboxItem
            checked={gridMode === 'full'}
            onCheckedChange={(v) => viewToggles.checkGridMode('full', v)}
          >
            Full Pica
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={gridMode === 'half'}
            onCheckedChange={(v) => viewToggles.checkGridMode('half', v)}
          >
            Half Pica
          </DropdownMenuCheckboxItem>
        </DropdownMenuSubContent>
      </DropdownMenuSub>
      {toggles.grid.map(renderToggle)}
      <DropdownMenuSeparator />
      {toggles.guides.map(renderToggle)}
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault()
          openGuidesDialog()
        }}
      >
        Set Columns & Rows Guides
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      {toggles.overlays.map(renderToggle)}
    </DesktopSubmenu>
  )
}
